import { NamespaceRO } from '@routellers/types/dist/translation/namespace.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = undefined;

type ResponseData = NamespaceRO[];

export const getAllNamespaces: ApiMethodDeclaration<ParamsData, ResponseData> = () => ({
    url: '/translations/namespaces',
    method: 'GET',
});
